export default "__VITE_ASSET__555f1477__"